import { Middleware } from '@reduxjs/toolkit';

import { authReducerName } from '@/store/reducers/auth-reducer';
import { setUserInStorage } from '@/utilities/storage';

export const persistMiddleware: Middleware = (store) => (next) => (action) => {
  const result = next(action);
  if ((action as { type: string }).type.includes(authReducerName)) {
    setUserInStorage(store.getState().auth.user || {});
  }
  return result;
};
